<form novalidate #motorsDescriptionAndPhotosPhotoSectionForm='ngForm' *ngIf='draftLoaded$ | async'>
    <tg-row class='motors-description-and-photos-photo-section__margin-bottom' *ngIf='displayError && !isMobile'>
        <tg-col md='6' sm='12'>
            <tg-info-box tgStyle='danger'>
                <tg-icon name='camera' alt='information'>
                </tg-icon>
                <tg-info-box-heading>
                    You need to add at least
                    {{ selectedPackage.minPhotoRequired }} photo(s) to select
                    a {{ selectedPackage.name }} listing.
                </tg-info-box-heading>
                Select a different listing type or add more photos.
            </tg-info-box>
        </tg-col>
    </tg-row>

    <tg-row>
        <tg-col md='6' sm='12'>
            <tm-list-photo-management
                name='photos'
                ngModel
                [photos]='photos'
                (photosUploading)='onPhotosUploading()'
                (photosUploaded)='onPhotosUploaded()'
                (photoSelected)='onPhotoSelected($event)'
                (photosUpdated)='onPhotosUpdated($event)'
                (photoTransformed)='onPhotoTransformed($event)'>
            </tm-list-photo-management>
        </tg-col>
    </tg-row>
</form>
